/**
 * 상품 상세의 옵션 선택값 보존 (localStorage).
 *
 * 페이지를 오가도 선택이 유지되도록 상품별로 저장하는데, **부고(상주)까지 키에 넣는다**.
 * 전화주문으로 여러 상주를 연달아 응대할 때 앞 상주의 옵션 선택이 그대로 남아
 * 모르는 채 그 옵션으로 주문될 수 있기 때문이다. (감사글·배송지와 같은 격리 원칙 —
 * state/giftInputOwner.ts 참고)
 */

const KEY_PREFIX = 'giftItemDetail:options:';

const bugoSegment = (bugoId: string | null | undefined) => bugoId ?? 'no-bugo';

/** 이 부고 + 이 상품의 옵션 저장 키 (상품이 없으면 빈 문자열 = 저장 안 함) */
export const giftItemOptionsStorageKey = (
  bugoId: string | null | undefined,
  itemId?: string,
): string => (itemId ? `${KEY_PREFIX}${bugoSegment(bugoId)}:${itemId}` : '');

/**
 * 부고 구분 없이 저장했던 구버전 키를 지운다.
 * 남겨두면 남의 옵션이 계속 떠다니므로 상세페이지 진입 시 정리한다.
 */
export const removeLegacyGiftItemOptionsKey = (itemId?: string): void => {
  if (!itemId) return;
  try {
    localStorage.removeItem(`${KEY_PREFIX}${itemId}`);
  } catch {
    /* 접근 실패 무시 */
  }
};

/** 이 부고로 저장된 옵션 선택 전부 삭제 — "주문서 정리"용 */
export const clearGiftItemOptionSelections = (
  bugoId: string | null | undefined,
): void => {
  try {
    const prefix = `${KEY_PREFIX}${bugoSegment(bugoId)}:`;
    const keys: string[] = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key?.startsWith(prefix)) keys.push(key);
    }
    keys.forEach((key) => localStorage.removeItem(key));
  } catch {
    /* 접근 실패 무시 */
  }
};
